/* eslint-disable */
import { codeMirrorEditorStyles } from "./codemirror-base.styles";

const styles = {
    root: {
        p: 2,
        border: "1px solid",
        borderColor: "greyscale.200",
        borderRadius: 2,
        mt: 1,
        backgroundColor: "background.paper",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        rowGap: 0.75,
    },
    titleGroup: {
        display: "flex",
        flexDirection: "column",
        gap: 0.25,
    },
    disclaimer: {
        fontSize: 11,
        color: "greyscale.500",
    },
    navControls: {
        display: "flex",
        alignItems: "center",
        gap: 0.5,
    },
    navCounter: {
        fontSize: 12,
        fontWeight: 600,
        color: "greyscale.800",
        minWidth: 36,
        textAlign: "center",
        userSelect: "none",
    },
    navArrow: {
        width: 26,
        height: 26,
        border: "1px solid",
        borderColor: "greyscale.300",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "greyscale.700",
        transition: "background-color 0.15s, border-color 0.15s",
        "&:hover": { backgroundColor: "greyscale.100", borderColor: "greyscale.400" },
    },
    actionChip: (active: boolean) => ({
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.3,
        borderRadius: "12px",
        border: active ? "1.5px solid" : "1px solid",
        borderColor: "warning.main",
        backgroundColor: active ? "rgba(245,158,11,0.18)" : "rgba(245,158,11,0.08)",
        fontSize: 11,
        fontWeight: 600,
        color: "warning.dark",
        whiteSpace: "nowrap",
        cursor: "pointer",
        transition: "background-color 0.15s",
        "&:hover": { backgroundColor: "rgba(245,158,11,0.22)" },
    }),
    fixedChip: (active: boolean) => ({
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.3,
        borderRadius: "12px",
        border: active ? "1.5px solid" : "1px solid",
        borderColor: "success.main",
        backgroundColor: active ? "rgba(34,197,94,0.18)" : "rgba(34,197,94,0.08)",
        fontSize: 11,
        fontWeight: 600,
        color: "success.dark",
        whiteSpace: "nowrap",
        cursor: "pointer",
        transition: "background-color 0.15s",
        "&:hover": { backgroundColor: "rgba(34,197,94,0.22)" },
    }),
    issueBanner: (type: "action" | "fixed" | undefined) => ({
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        px: 1.5,
        py: 1,
        borderRadius: 1,
        border: "1px solid",
        ...(type === "action"
            ? { borderColor: "warning.main", backgroundColor: "rgba(245,158,11,0.08)" }
            : { borderColor: "success.main", backgroundColor: "rgba(34,197,94,0.08)" }),
    }),
    issueBannerIcon: {
        fontSize: "16px !important",
        flexShrink: 0,
        mt: "1px",
    },
    editorWrapper: {
        flex: 1,
        minWidth: 0,
        ...codeMirrorEditorStyles,
        "& .CodeMirror": {
            ...codeMirrorEditorStyles["& .CodeMirror"],
            height: "600px",
        },
        "& .tql-fix-gutter": {
            width: "20px",
        },
    },
    buttonsRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 1,
    },
    buttonsRowRight: {
        display: "flex",
        alignItems: "center",
        gap: 1,
    },
};

export default styles;
